/**
 * ConsoleProvider mirrors every analytics call to the browser console with a
 * `[analytics]` prefix. It exists so developers can validate event wiring
 * without needing a PostHog project — enabled via REACT_APP_ANALYTICS_DEBUG=1.
 *
 * @implements {import('../AnalyticsService').AnalyticsProvider}
 */
export class ConsoleProvider {
  constructor() {
    this._sessionId = `console-${Math.random().toString(36).slice(2, 10)}`;
  }

  get name() {
    return "console";
  }

  async init() {
    return this;
  }

  isReady() {
    return true;
  }

  identify(userId, traits) {
    // eslint-disable-next-line no-console
    console.info("[analytics] identify", { userId, traits });
  }

  reset() {
    // eslint-disable-next-line no-console
    console.info("[analytics] reset");
    this._sessionId = `console-${Math.random().toString(36).slice(2, 10)}`;
  }

  track(eventName, properties) {
    // eslint-disable-next-line no-console
    console.info(`[analytics] ${eventName}`, properties);
  }

  setPersonProperties(traits) {
    // eslint-disable-next-line no-console
    console.info("[analytics] set person properties", traits);
  }

  registerSuperProperties(traits) {
    // eslint-disable-next-line no-console
    console.info("[analytics] register super properties", traits);
  }

  getSessionId() {
    return this._sessionId;
  }

  getSessionReplayUrl() {
    return null;
  }
}
